import { render, staticRenderFns } from "./PaginationBar.vue?vue&type=template&id=398f68a0&scoped=true&"
import script from "./PaginationBar.vue?vue&type=script&lang=ts&"
export * from "./PaginationBar.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationBar.vue?vue&type=style&index=0&id=398f68a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f68a0",
  null
  
)

export default component.exports